/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMediaFromJSON, ApiMediaToJSON, } from './ApiMedia';
export function ApiMediaFileFromJSON(json) {
    return ApiMediaFileFromJSONTyped(json, false);
}
export function ApiMediaFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
        'fileType': !exists(json, 'fileType') ? undefined : json['fileType'],
        'fullPath': !exists(json, 'fullPath') ? undefined : json['fullPath'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'media': !exists(json, 'media') ? undefined : ApiMediaFromJSON(json['media']),
        'mediaId': !exists(json, 'mediaId') ? undefined : json['mediaId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiMediaFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'fileName': value.fileName,
        'filePath': value.filePath,
        'fileType': value.fileType,
        'fullPath': value.fullPath,
        'id': value.id,
        'media': ApiMediaToJSON(value.media),
        'mediaId': value.mediaId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
